import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import { Compose, withProps } from 'src/utils/Compose';
import {
  AnalyticsProvider,
  ConfigProvider,
  ContractProvider,
  FeatureProvider,
  LinkProvider,
  LocaleProvider,
  ModalSettingsProvider,
  PostMessageProvider,
  TemporaryAnalyticsBridge,
} from 'src/providers';
// import { HoneybadgerErrorBoundary } from 'src/components/ErrorHandling/HoneybadgerErrorBoundary';

import { Interstitial } from 'src/components/Interstitial';
import { GlobalStyles } from 'src/GlobalStyles';
// import reportWebVitals from './reportWebVitals';

// Export this so it can be used in tests
export default function ModalEntry() {
  return (
    <Compose components={[
      // HoneybadgerErrorBoundary,
      withProps<typeof PostMessageProvider>({ source: 'modal' })(PostMessageProvider),
      LocaleProvider,
      AnalyticsProvider,
      ConfigProvider,
      withProps<typeof FeatureProvider>({ context: 'modal' })(FeatureProvider),
      ContractProvider,
      TemporaryAnalyticsBridge,
      LinkProvider,
    ]}>
      <ModalSettingsProvider>
        <GlobalStyles />
        <Interstitial />
      </ModalSettingsProvider>
    </Compose>
  );
}

if (process.env.NODE_ENV !== 'test') {
  const root = document.getElementById('root');
  if (root) {
    ReactDOM.createRoot(root).render(<ModalEntry />);
  }
}
